/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 24/11/2013
 * Time: 15:49
 * To change this template use File | Settings | File Templates.
 */


angular.module('FlexyBeautyApp.services').
    factory('AvailableTableView',["$timeout","Period","DaySrv","DayData","SiteData","AvailableDayView","DateSrv", 
        function ($timeout,Period,DaySrv,DayData,SiteData,AvailableDayView,DateSrv){

        var  AvailableTableView = function(site,domainView) {
            //Load planning view according site
            // If first date values is filled : the view is related to the planning
            // if not it's related to the config week of persons

            this.domainView = domainView; //Set by initializer
            this.aSlotsRefView = [];//lines of the planning (10h00,12h00,14h00 etcc.) : contains period
            this.aDaysView = [];
            this.aDaysViewDisplayed = [];
            this.period = site.getMaxOpeningPeriod();
            this.loading = true;
            this.firstDateDisplayed = null;
            this.firstDayIndexDisplayed =null;
            this.modelTodayIndex=-1;
            this.triesTime = domainView.ad.appAttributes.triesTime;
            this.autoFilling = domainView.ad.appAttributes.autoFilling;
            this.triesTimeLimit = 55;//when availability start at not a rounded time (ex : 10h20) -> propositions of reservations will be 10h20 10h35 10h45. This behaviour start if triesTime <=  triesTimeLimit
            this.tableModeHour = this.triesTime<60;
            this.hasDiscount = false;
            var today = new Date();
            this.modelTodayIndex  = today.getDay() -1;//day of week;
            if (this.modelTodayIndex==-1)//Sunday
                this.modelTodayIndex=6;//Sunday
            this.firstDayIndexDisplayed = this.modelTodayIndex;
            this.selected =
                {
                    humanResourceView : null,
                    aSlotView : null,
                    aTimeView : null,
                    hasAvailability : false

                };
            this.initTime(this.period);

            //working Period aggregation
            var nbWeeks = 1;
            for (var w = 0;w<nbWeeks;w++)
                this.addWeekView(site,w*7,false);

            //this.updateDisplay(this.getFirstADayViewByDayIndex(this.firstDayIndexDisplayed));

            this.loading = false;
        };

        AvailableTableView.prototype.initTime = function(period)
        {
            //3 periods : morning , start afternoon, end afternoon

            var cPeriod;
            var hour = period.start.hour;
            this.aSlotsRefView =[];
            while (hour <= period.end.hour)
            {
                cPeriod = new Period ();
                cPeriod.setStartHour(hour);
                cPeriod.setEndHour(hour+1);
                this.aSlotsRefView.push (cPeriod);
                hour ++;
            }

        }
        AvailableTableView.prototype.addWeekView = function(site,dayIndexStart,insertBefore)
        {
            var days = DayData.getActiveList();
            var dayOfWeekView = null;
            var aDayViewLastIndex=0;
            for (var i = dayIndexStart; i < days.length && i < (dayIndexStart + 7); i++) //Days of week
            {
                dayOfWeekView = new AvailableDayView(days[i],i,this);
                if (insertBefore)
                {
                    this.aDaysView.splice(aDayViewLastIndex,0,dayOfWeekView);
                    aDayViewLastIndex++;
                }
                else
                    this.aDaysView.push(dayOfWeekView);
            }
        };
        AvailableTableView.prototype.updateAvailability = function(bookingView)
        {
            if (this.selected)
            {
                this.selected.hasAvailability =false;
                for (var i = 0; i<this.aDaysView.length;i++)
                    this.selected.hasAvailability = this.aDaysView[i].updateAvailability(bookingView) || this.selected.hasAvailability;

            }
        };
        AvailableTableView.prototype.getDiscountDays = function()
        {
            var discountWeek = {aDaysView : []};
            var discountDay;
            for (var k = 0; k < this.aDaysView.length; k++)
            {
                discountDay =   this.aDaysView[k].getDiscountDays();
                if (discountDay)
                    discountWeek.aDaysView.push(discountDay);
            }

            return discountWeek;
        };
        AvailableTableView.prototype.setByDiscountDays = function(discountDays)
        {
            for (var i = 0; i <discountDays.aDaysView.length; i++)
                for (var k = 0; k < this.aDaysView.length; k++)
                    if (discountDays.aDaysView[i].dayId==DaySrv.getIdFromDate(this.aDaysView[k].date)) {
                        this.aDaysView[k].setByDiscountDays(discountDays.aDaysView[i]);
                        if (this.aDaysView[k].hasDiscount)
                            this.hasDiscount = true;
                    }
        };
        AvailableTableView.prototype.getFirstADayViewByDayIndex = function(dayIndex)
        {
            //return first aDaysView with a model index >= dayIndex (first open day)
            for (var k = 0; k < this.aDaysView.length; k++)
                if (this.aDaysView[k].dayIndex >= dayIndex)
                        return this.aDaysView[k];
            return null;
        };

        AvailableTableView.prototype.updateDisplay = function(firstADayViewParam)
        {
            var nbDisplayedLimit = this.dim.nbDays;
            var firstADayView;
            if (firstADayViewParam)
                firstADayView = firstADayViewParam;
            if (this.dim.nbDays==7)//displayWeekMode
            {
                var indexTarget;
                nbDisplayedLimit = this.nbOpenDaysByWeek;
                indexTarget = (Math.floor(this.firstDayIndexDisplayed/7)*7);//round to first day of week
                if (indexTarget!=this.firstDayIndexDisplayed)
                {
                    firstADayView = this.getFirstADayViewByDayIndex(indexTarget);
                    this.firstDayIndexDisplayed = firstADayView.dayIndex;
                }
            }
            if (!firstADayView )
            {
                firstADayView = this.getFirstADayViewByDayIndex(this.firstDayIndexDisplayed);
                this.firstDayIndexDisplayed = firstADayView.dayIndex;
            }
            //Display Only Open Days : add correct days to aDaysViewDisplayed
            var nbDisplayed = 0;
            this.firstDateDisplayed = firstADayView.date;
            this.aDaysViewDisplayed = [];
            var k;
            for (k = this.aDaysView.indexOf(firstADayView); k < this.aDaysView.length && nbDisplayed<nbDisplayedLimit; k++)
                if (this.aDaysView[k].dayIndex>=this.firstDayIndexDisplayed)
                {
                    this.aDaysViewDisplayed.push( this.aDaysView[k]);
                    nbDisplayed ++;
                }
            if (nbDisplayed!=this.dim.nbDaysDisplayed)
                this.updateFontSize();
            this.dim.nbDaysDisplayed =  nbDisplayed;

        }


        return  AvailableTableView;
    }]);




// WEBPACK FOOTER //
// ./js/services/customerSite/views/AvailableTableView.js